import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    
    // Сначала обрабатываем спец-токены системы (вход, верификация, сброс пароля)
    if (searchParams.has('magic_token')) {
      navigate(`/login${window.location.search}`);
      return;
    }

    if (searchParams.has('token')) {
      const path = window.location.pathname;
      if (path.includes('verify-email')) {
        navigate(`/verify-email${window.location.search}`);
      } else {
        navigate(`/reset-password${window.location.search}`);
      }
      return;
    }

    // Если токенов нет — перенаправляем на новый лендинг на Тильде
    window.location.href = 'https://svod.pro';
  }, [navigate]);

  // Пока идет редирект, показываем пустой экран или лоадер
  return null;
};

export default Home;
